import { render, staticRenderFns } from "./UserDrawer.vue?vue&type=template&id=1a33c69a&scoped=true"
import script from "./UserDrawer.vue?vue&type=script&lang=js"
export * from "./UserDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a33c69a",
  null
  
)

export default component.exports